// extracted by mini-css-extract-plugin
export default {"box":"style_box__y+bsy","close":"style_close__IHSwi","img":"style_img__23vCX"};